export default {
    methods:{
        toggleModal(modalRef){
            this.$refs[modalRef].toggle();
        }
    }
};
